"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _sortable = require("@dnd-kit/sortable");

var _utilities = require("@dnd-kit/utilities");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SortableItem = function SortableItem(_ref) {
  var sortId = _ref.sortId,
      Component = _ref.as,
      className = _ref.className,
      children = _ref.children;

  var _useSortable = (0, _sortable.useSortable)({
    id: sortId
  }),
      attributes = _useSortable.attributes,
      listeners = _useSortable.listeners,
      setNodeRef = _useSortable.setNodeRef,
      transform = _useSortable.transform,
      transition = _useSortable.transition;

  var style = {
    transform: _utilities.CSS.Transform.toString(transform),
    transition: transition
  };
  return (0, _jsxRuntime.jsx)(Component, _objectSpread(_objectSpread(_objectSpread({
    className: className,
    ref: setNodeRef,
    style: style
  }, attributes), listeners), {}, {
    children: children && children
  }));
};

SortableItem.propTypes = {
  as: _propTypes.elementType,
  sortId: _propTypes.string.isRequired,
  className: _propTypes.string,
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
SortableItem.defaultProps = {
  as: 'div',
  className: undefined,
  children: undefined
};
var _default = SortableItem;
exports["default"] = _default;
//# sourceMappingURL=SortableItem.js.map